import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private SearchInput = new EventEmitter<string>();
  private SearchResults = new EventEmitter<object>();
  private SearchLoading = new EventEmitter<boolean>();
  private SearchClose = new EventEmitter();
  private SearchVisible = new EventEmitter<boolean>();

  constructor() {}
  ngOnInit() {}

  public SendSearchInput(value: string) {
    this.SearchInput.emit(value);
  }

  public SendSearchResults(results: any) {
    this.SearchResults.emit(results);
  }

  public SetSearchLoading(isLoading: boolean) {
    this.SearchLoading.emit(isLoading);
  }

  public SetSearchVisible(isVisible: boolean) {
    this.SearchVisible.emit(isVisible);
  }

  public CloseSearch() {
    this.SearchClose.emit();
  }

  public GetSearchInputEmitter() {
    return this.SearchInput;
  }

  public GetSearchResultsEmitter(): any {
    return this.SearchResults;
  }

  public GetSearchLoadingEmitter() {
    return this.SearchLoading;
  }

  public GetSearchCloseEmitter() {
    return this.SearchClose;
  }

  public GetSearchVisibleEmitter() {
    return this.SearchVisible;
  }

  public SearchEmitterCleanup() {
    this.SearchInput.observers.shift();
  }
}
